import { Component } from "@theme/component";
import { debounce } from "@theme/utilities";

class FooterEffect extends Component {
  #scrollClass = 'footer-scroll-effect';
  #minSectionRatio = 1.5;
  #viewportHeight = 0;
  #viewportWidth = 0;

  connectedCallback() {
    super.connectedCallback();

    this.#viewportHeight = window.innerHeight;
    this.#viewportWidth = window.innerWidth;

    this.#update();
    window.addEventListener('resize', this.#handleResize, { passive: true });
    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.#handleEditorBlockSelect);
      document.addEventListener('shopify:section:load', this.#update);
      document.addEventListener('shopify:section:unload', this.#handleSectionUnload);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.#handleResize);
    if (Shopify.designMode) {
      document.removeEventListener('shopify:block:select', this.#handleEditorBlockSelect);
      document.removeEventListener('shopify:section:load', this.#update);
      document.removeEventListener('shopify:section:unload', this.#handleSectionUnload);
    }
    this.#handleResize.cancel();
    document.body.classList.remove(this.#scrollClass);
  }

  #handleResize = debounce(() => {
    this.#viewportHeight = window.innerHeight;
    this.#viewportWidth = window.innerWidth;
    this.#update();
  }, 150);

  // Defer update after section:unload so the removed footer is no longer in the DOM
  #handleSectionUnload = () => setTimeout(this.#update, 0);

  #handleEditorBlockSelect = (event) => {
    if (!(event.target instanceof Element) || !this.contains(event.target)) return;
    this.#update();
  };

  #isLastFooter = () => {
    const allWithEffect = document.querySelectorAll('footer[is="footer-effect"]');
    if (allWithEffect.length === 0 || allWithEffect[allWithEffect.length - 1] !== this) return false;
    // Also ensure no footer section exists after this one (e.g. a footer with effect disabled)
    const allFooters = document.querySelectorAll('footer.footer-section');
    return allFooters[allFooters.length - 1] === this;
  };

  #update = () => {
    // Only the last footer manages the body class — others do nothing
    if (!this.#isLastFooter()) return;

    const hasRequiredRootHeight = document.body.offsetHeight >= this.#viewportHeight * this.#minSectionRatio;
    const footerHeight = this.offsetHeight;
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;

    if (
      this.#viewportWidth < 1025
      || !hasRequiredRootHeight
      || footerHeight + headerHeight > this.#viewportHeight
    ) {
      document.body.classList.remove(this.#scrollClass);
      return;
    }

    document.body.classList.add(this.#scrollClass);
  };
}

if (!customElements.get('footer-effect')) {
  customElements.define('footer-effect', FooterEffect, { extends: 'footer' });
}
